/* eslint-disable @typescript-eslint/naming-convention */

export interface NotificationWizardResource {
    id?: string;

    targetGroupKey?: string;
    targetGroupName?: string;
    partner?: string;
    users?: string;
    userIds?: number[];
    groupIds?: number[];
    companyId?: number | null;
    step?: NotificationWizardSteps;
    filter?: string;
    userList?: any[];
    groupList?: any[];
    companyList?: any[];
    userCount?: number;
    androidMessage?: string;
    iosMessage?: string;
    whatsappMessage?: string;
    subject?: string;
    message?: string;
    sendTime?: string;
    sendNow?: boolean;
    singleOffer?: boolean;

    offers?: [{name: string; id: number}];
    attachedDocuments?: [{name: ''; file: ''}];

    filters?: any;
    attachmentType?: any // Typ přílohy
    attachment?: string; // Příloha
    richContent?: string; // Rich content text
    link?: string; // Link for rich content type

}

export enum NotificationWizardSteps {
    Filter,             // Vypis vyfiltrovanych uzivatelu
    Text,               // Textace
    Summaray,           // Potvrzeni a odeslani
}

export interface NotifCanalResource {
    name: string;
    key: string;
    id: number;
}
